import { ChangeEvent, forwardRef, useState } from 'react';
import cx from 'clsx';
import styles from './Checkbox.module.css';
import { v4 as uuidv4 } from 'uuid';

export type SquareCheckBoxProps = {
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  disabled?: boolean;
  checked?: boolean;
  showError?: boolean;
};

export const SquareCheckBox = forwardRef<HTMLInputElement, SquareCheckBoxProps>(
  (props, ref) => {
    const [checked, setChecked] = useState(props.checked ?? false);
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      setChecked(event.target.checked);
      if (props.onChange && !props.disabled) {
        props.onChange(event);
      }
    };
    const id = uuidv4();

    return (
      <div
        className={cx(
          `bg-background-default ${props.disabled ? 'border-ui-disabled' : 'border-ui-border'} relative h-10 w-10 flex-shrink-0 rounded border`,
          styles['checkbox-wrapper'],
        )}
      >
        <input
          disabled={props.disabled}
          id={props.id ?? id}
          type="checkbox"
          className={`absolute z-[999] mt-0 h-full w-full opacity-0 ${props.disabled ? 'cursor-not-allowed' : 'cursor-auto'}`}
          checked={checked}
          name={props.name}
          ref={ref}
          onChange={handleChange}
        />
        {checked && !props.disabled ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : null}
      </div>
    );
  },
);

SquareCheckBox.displayName = 'SquareCheckbox';
